<template>
  <div class="inline-flex items-center">
    <input
      type="checkbox"
      :checked="modelValue"
      :value="true"
      class="w-4 h-4 text-primary-500 bg-gray-100 border-gray-300 rounded
        focus:ring-primary-500 dark:focus:ring-primary-600 dark:ring-offset-gray-800
        focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
      v-bind="$attrs"
      @input="$emit('update:modelValue', $event.target.checked)">
    <input
      v-if="!modelValue"
      type="hidden"
      :value="false"
      v-bind="$attrs">
    <label v-if="label" :for="$attrs.id" class="ml-2 text-gray-900 dark:text-white">{{ label }}</label>
  </div>
</template>

<script setup>
import { defineOptions } from 'vue'

defineOptions({ inheritAttrs: false })

defineProps({
  label: {
    type: String, required: false, default: ''
  },
  modelValue: {
    required: true,
    validator: (prop) => typeof prop === 'boolean' || prop === null || prop === undefined
  }
})

defineEmits(['update:modelValue'])
</script>
